import { createSlice } from "@reduxjs/toolkit";
import { LayoutState } from "../types/SlicesTypes";

const initialState: LayoutState = {
  pageContentMargin: 0,
  layoutProps: {
    headerProps: {
      restaurantInfo: null,
      components: [],
      backLink: null,
      currentPage: null,
      dynamicPagination: null,
      display: false,
    },
    footerProps: {
      text: "",
      price: 0,
      link: null,
      click: null,
      display: false,
      testId: "Footer", // to be removed
    },
  },
};

const LayoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setPageContentMargin: (state, { payload }) => {
      state.pageContentMargin = payload;
    },
    setLayoutProps: (state, { payload }) => {
      state.layoutProps = payload;
    },
    setLayoutButtonToLoading: (state, { payload }) => {
      state.layoutProps.footerProps.isLoading = payload;
    },
  },
});

export const {
  setPageContentMargin,
  setLayoutProps,
  setLayoutButtonToLoading,
} = LayoutSlice.actions;

export default LayoutSlice.reducer;
